/*
 * @Author: Vir
 * @Date: 2021-12-17 09:50:33
 * @Last Modified by: Vir
 * @Last Modified time: 2021-12-18 21:18:08
 */

const websiteIconApis = [
  {
    id: '2c246ed9c0c04dc0ace396872f22ce36',
    name: '松鼠API',
    url: 'https://api.szfx.top/ico/?url=',
  },
  {
    id: 'd013ba04dfe247f89f6e057ac3a33e73',
    name: 'Proxy favicon',
    url: 'http://statics.dnspod.cn/proxy_favicon/_/favicon?domain=',
  },
  {
    id: 'b2f515ed5284484c8bce03064812aa9c',
    name: 'Clowntool',
    url: 'https://api.clowntool.cn/getico/?url=',
  },
  {
    id: '932291dd3cf344c7be335bc0922bd214',
    name: 'Google',
    url: 'http://www.google.cn/s2/favicons?domain=',
  },
  {
    id: 'e26bf8091dae47039833f673ec24bced',
    name: 'Iowen',
    url: 'https://api.iowen.cn/favicon/get.php?url=',
  },
];

export default websiteIconApis;
